<div class="manual-triggers-container">
  <div class="page-header">
    <h2>
      <mat-icon>settings_suggest</mat-icon>
      Manual Triggers
    </h2>
    <p>Administrative Funktionen zum manuellen Auslösen von Prozessen, Migrationen und Datenexporten.</p>
  </div>

  <mat-tab-group>
    <mat-tab label="🏢 Organisationen">
      <div class="tab-content">
        <div class="section section-primary">
          <h3>
            <mat-icon>business</mat-icon>
            Organisationen-Import
          </h3>
          <p class="help-text">Aktualisiert automatisch alle Organisationen aus dem Lakehouse.</p>
          <div class="button-container">
            <button
              mat-raised-button
              color="primary"
              (click)="triggerOrganizationImport()"
              [disabled]="isLoadingOrganizations">
              <mat-icon *ngIf="!isLoadingOrganizations">play_arrow</mat-icon>
              <mat-icon *ngIf="isLoadingOrganizations">hourglass_empty</mat-icon>
              {{ isLoadingOrganizations ? 'Lädt...' : 'Organisationen aktualisieren' }}
            </button>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="🔄 Migrationen">
      <div class="tab-content">
        <div class="section section-warn">
          <h3>
            <mat-icon>sync</mat-icon>
            Recommendation Titel Migration
          </h3>
          <p class="help-text">
            <strong>⚠️ Vorsicht:</strong> Migriert alle Recommendation-Titel. Diese Aktion kann längere Zeit dauern.
          </p>
          <div class="button-container">
            <button
              mat-raised-button
              color="warn"
              (click)="triggerRecommendationTitleMigration()"
              [disabled]="isLoadingRecommendationTitles">
              <mat-icon *ngIf="!isLoadingRecommendationTitles">sync</mat-icon>
              <mat-icon *ngIf="isLoadingRecommendationTitles">hourglass_empty</mat-icon>
              {{ isLoadingRecommendationTitles ? 'Migriert...' : 'Titel migrieren' }}
            </button>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="📋 Status Updates">
      <div class="tab-content">
        <div class="section section-success">
          <h3>
            <mat-icon>update</mat-icon>
            Recommendation Status Update
          </h3>
          <p class="help-text">
            Aktualisiert alle pending Recommendations basierend auf ihren Deadlines und sendet Reminder-E-Mails.
            <strong>Diese Funktion wird normalerweise stündlich automatisch ausgeführt.</strong>
          </p>
          <div class="button-container">
            <button
              mat-raised-button
              color="primary"
              (click)="triggerRecommendationStateUpdate()"
              [disabled]="isLoadingRecommendationStateUpdate">
              <mat-icon *ngIf="!isLoadingRecommendationStateUpdate">update</mat-icon>
              <mat-icon *ngIf="isLoadingRecommendationStateUpdate">hourglass_empty</mat-icon>
              {{ isLoadingRecommendationStateUpdate ? 'Aktualisiert...' : 'Status aktualisieren' }}
            </button>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="👤 Benutzer">
      <div class="tab-content">
        <mat-tab-group>
          <mat-tab label="📝 Display-Namen">
            <div class="sub-tab-content">
              <div class="section section-accent">
                <h3>
                  <mat-icon>badge</mat-icon>
                  Display-Name aktualisieren
                </h3>
                <p class="help-text">
                  Geben Sie ein JSON-Array mit User-Mappings ein. Jedes Objekt muss die Felder
                  <strong>azureId</strong> (Azure User GUID) und <strong>notesName</strong> (Display-Name aus Notes)
                  enthalten.
                </p>

                <div class="example-container">
                  <div class="example-header">
                    <span class="example-label">Beispiel-Datenstruktur:</span>
                    <button
                      mat-icon-button
                      matTooltip="Beispiel in Zwischenablage kopieren"
                      (click)="copyExampleToClipboard()"
                      [disabled]="isLoadingUserDisplayNames"
                      class="copy-button">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </div>
                  <pre class="example-json">{{ exampleJson }}</pre>
                </div>

                <mat-form-field
                  appearance="outline"
                  class="full-width">
                  <mat-label>User Mappings (JSON)</mat-label>
                  <textarea
                    matInput
                    [(ngModel)]="userMappingJson"
                    placeholder='[{"azureId": "12345678-1234-1234-1234-123456789012", "notesName": "Max Mustermann"}, {"azureId": "87654321-4321-4321-4321-210987654321", "notesName": "Anna Schmidt"}]'
                    rows="8"
                    [disabled]="isLoadingUserDisplayNames"></textarea>
                  <mat-hint> Format: Array von Objekten mit "azureId" (GUID) und "notesName" (String) </mat-hint>
                </mat-form-field>

                <div class="button-container">
                  <button
                    mat-raised-button
                    color="accent"
                    (click)="triggerUserDisplayNameMigration()"
                    [disabled]="isLoadingUserDisplayNames">
                    <mat-icon *ngIf="!isLoadingUserDisplayNames">person</mat-icon>
                    <mat-icon *ngIf="isLoadingUserDisplayNames">hourglass_empty</mat-icon>
                    {{ isLoadingUserDisplayNames ? 'Aktualisiere...' : 'User Display-Namen aktualisieren' }}
                  </button>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="🔗 Graph Matches">
            <div class="sub-tab-content">
              <div class="section section-primary">
                <h3>
                  <mat-icon>auto_fix_high</mat-icon>
                  Graph API Matches automatisch anwenden
                </h3>
                <p class="help-text">
                  Wendet automatisch alle eindeutigen Matches (MatchCount = 1) auf ungültige User-IDs an.
                </p>

                <div class="options-container">
                  <mat-form-field
                    appearance="outline"
                    class="option-field">
                    <mat-label>Namens-Matching Strategie</mat-label>
                    <mat-select [(ngModel)]="graphMatchOptions.nameMatchingStrategy">
                      <mat-option [value]="0">Normalisiert (Standard)</mat-option>
                      <mat-option [value]="1">Exakt</mat-option>
                      <mat-option [value]="2">Vor- und Nachname</mat-option>
                    </mat-select>
                    <mat-hint>Wie sollen Namen verglichen werden?</mat-hint>
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    class="option-field">
                    <mat-label>Email Domain Filter (optional)</mat-label>
                    <input
                      matInput
                      placeholder="z.B. autoneum.com"
                      [(ngModel)]="graphMatchOptions.emailDomainFilter" />
                    <mat-hint>Nur Azure Users mit dieser Domain berücksichtigen</mat-hint>
                  </mat-form-field>
                </div>

                <div class="button-container">
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="applyGraphMatches()"
                    [disabled]="isApplyingGraphMatches">
                    <mat-icon *ngIf="!isApplyingGraphMatches">auto_fix_high</mat-icon>
                    <mat-icon *ngIf="isApplyingGraphMatches">hourglass_empty</mat-icon>
                    {{ isApplyingGraphMatches ? 'Wende Matches an...' : 'Graph API Matches automatisch anwenden' }}
                  </button>
                </div>
              </div>

              <div class="section section-accent">
                <h3>
                  <mat-icon>person_search</mat-icon>
                  Graph API Matches manuell anwenden
                </h3>
                <p class="help-text">
                  Für Matches, die nicht automatisch zugeordnet werden können (kein Match oder mehrere mögliche
                  Matches), können Sie hier manuell einen Azure User auswählen und den Match anwenden.
                </p>
                <app-manual-graph-matches></app-manual-graph-matches>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="📊 Exports">
            <div class="sub-tab-content">
              <div class="section section-primary">
                <h3>
                  <mat-icon>download</mat-icon>
                  Basis-Exports
                </h3>
                <p class="help-text">Exportieren Sie ungültige User-IDs in verschiedenen Formaten für die Analyse.</p>

                <div class="button-container">
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="exportInvalidUserIds()"
                    [disabled]="isLoadingInvalidUserIds">
                    <mat-icon *ngIf="!isLoadingInvalidUserIds">download</mat-icon>
                    <mat-icon *ngIf="isLoadingInvalidUserIds">hourglass_empty</mat-icon>
                    {{ isLoadingInvalidUserIds ? 'Exportiere...' : 'Excel Export' }}
                  </button>

                  <button
                    mat-raised-button
                    color="primary"
                    (click)="exportInvalidUserIdsStatistics()"
                    [disabled]="isLoadingInvalidUserIdsStatistics">
                    <mat-icon *ngIf="!isLoadingInvalidUserIdsStatistics">bar_chart</mat-icon>
                    <mat-icon *ngIf="isLoadingInvalidUserIdsStatistics">hourglass_empty</mat-icon>
                    {{ isLoadingInvalidUserIdsStatistics ? 'Exportiere...' : 'Statistiken' }}
                  </button>
                </div>
              </div>

              <div class="section section-accent">
                <h3>
                  <mat-icon>search</mat-icon>
                  Export mit Graph API Matches
                </h3>
                <p class="help-text">
                  Exportiert ungültige User-IDs zusammen mit automatisch gefundenen Graph API Matches zur Analyse.
                </p>

                <div class="options-container">
                  <mat-form-field
                    appearance="outline"
                    class="option-field">
                    <mat-label>Namens-Matching Strategie</mat-label>
                    <mat-select [(ngModel)]="graphMatchOptions.nameMatchingStrategy">
                      <mat-option [value]="0">Normalisiert (Standard)</mat-option>
                      <mat-option [value]="1">Exakt</mat-option>
                      <mat-option [value]="2">Vor- und Nachname</mat-option>
                    </mat-select>
                    <mat-hint>Wie sollen Namen verglichen werden?</mat-hint>
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    class="option-field">
                    <mat-label>Email Domain Filter (optional)</mat-label>
                    <input
                      matInput
                      placeholder="z.B. autoneum.com"
                      [(ngModel)]="graphMatchOptions.emailDomainFilter" />
                    <mat-hint>Nur Azure Users mit dieser Domain berücksichtigen</mat-hint>
                  </mat-form-field>
                </div>

                <div class="button-container">
                  <button
                    mat-raised-button
                    color="accent"
                    (click)="exportInvalidUserIdsWithMatches()"
                    [disabled]="isLoadingInvalidUserIdsWithMatches">
                    <mat-icon *ngIf="!isLoadingInvalidUserIdsWithMatches">search</mat-icon>
                    <mat-icon *ngIf="isLoadingInvalidUserIdsWithMatches">hourglass_empty</mat-icon>
                    {{ isLoadingInvalidUserIdsWithMatches ? 'Suche Matches...' : 'Export mit Matches' }}
                  </button>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
